/// <reference path="../../node_modules/@types/jquery/index.d.ts" />


export class NavigationUtility {

    // This method is used to reload the page when the user navigates back to the page using the browser back button.
    public static ReloadPageOnBackButtonNavigation() {
        window.addEventListener("pageshow", function (event) {
            var historyTraversal = event.persisted ||
                (typeof window.performance != "undefined" &&
                    window.performance.navigation.type === 2);
            if (historyTraversal) {
                // Handle page restore.
                window.location.reload();
            }
        });
    }
}

